/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResetPasswordInput } from '../../models/reset-password-input';
import { Response } from '../../models/response';

export interface ApiIdentityAccountResetpasswordPost$Plain$Params {
      body?: ResetPasswordInput
}

export function apiIdentityAccountResetpasswordPost$Plain(http: HttpClient, rootUrl: string, params?: ApiIdentityAccountResetpasswordPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityAccountResetpasswordPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiIdentityAccountResetpasswordPost$Plain.PATH = '/api/identity/account/resetpassword';
